var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"claw-section",on:{"click":function($event){return _vm.$parent.openPrizePage()}}},[_c('img',{staticClass:"bg-image",attrs:{"src":_vm._global.isMobile 
                       ? _vm._global.assetsRoot + '/mobile/entrance_claw_' + [_vm._i18n.locale] + '.png' 
                       : _vm._global.assetsRoot + '/desktop/entrance_claw_' + [_vm._i18n.locale] + '.png',"alt":""}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c236acd","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/claw.vue
// module id = 423
// module chunks = 0